import { Layout } from 'antd';
import { Fragment } from 'react/jsx-runtime';
import { useState } from 'react';
import Navbar from '../navbar';
import Sidebar from '../sidebar';

function Content({ children }) {
    const [collapsed, setCollapsed] = useState(true);
    return (
        <div style={{ height: '100vh', overflow: 'hidden' }}>
            <Layout style={{ height: '100%' }}>
                <Layout.Header
                    style={{
                        background: 'white',
                        boxShadow: '0px 5px 8px rgba(168, 216, 243, 0.5)',
                        padding: '0px 8px',
                    }}
                    id="em-header"
                >
                    <Navbar setCollapsed={setCollapsed} />
                </Layout.Header>
                <Layout id="em-wrapper">
                    <Fragment>
                        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
                        <div style={{ zIndex: 'inherit', width: '100%', overflow: 'auto' }}>{children}</div>
                    </Fragment>
                </Layout>
            </Layout>
        </div>
    );
}

export default Content;
